<div *ngIf="message" class="alert alert-danger text-center" role="alert">
  {{ message | slice : 0 : 55 }}
  <a href="mailto:support@petszel.com">support&#64;petszel.com</a>.
</div>
